import { render, staticRenderFns } from "./GanttTests.vue?vue&type=template&id=391b7bbb&"
import script from "./GanttTests.vue?vue&type=script&lang=js&"
export * from "./GanttTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports